import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import api from '../../../api';
import UserAvatar from '../../../assets/user-avatar.png';
import { LangKey } from '../../../intl';
import fb from '../../../services/firebase.service';
import { useAuthState } from '../../../state/auth';
import { useDialogs } from '../../../state/dialogs';
import { useIntl } from '../../../state/intl';
import { delay } from '../../../utils/delay';
import useErrors from '../../../utils/hooks/errors.hooks';
import useSnacks from '../../../utils/hooks/snacks.hooks';

interface UserMenuProps {}

const UserMenu: React.FC<UserMenuProps> = () => {
  const handleErr = useErrors();
  const { user } = useAuthState();
  const { confirm } = useDialogs();
  const { showSuccess } = useSnacks();
  const { lang } = useIntl();

  async function performLogout() {
    await delay(1000);
    return fb.auth().signOut();
  }

  function onLogout() {
    confirm({
      title: tx.logoutDialog.title,
      content: tx.logoutDialog.content,
      onMainAction: performLogout,
    });
  }

  async function handleResetPsw() {
    try {
      await api.request('auth/resetPassword', { email: user!.email });
      showSuccess();
    } catch (err) {
      handleErr(err);
    }
  }

  function onResetPsw() {
    confirm({
      title: 'Reset Password',
      content: tx.resetPasswordDialog.content,
      onMainAction: handleResetPsw,
    });
  }

  const txs: {
    [key in LangKey]: {
      logout: string;
      logoutDialog: {
        title: string;
        content: string;
      };
      resetPasswordDialog: {
        content: string;
      };
    };
  } = {
    en: {
      logout: 'Logout',
      logoutDialog: {
        title: 'Logout',
        content: 'Do you really want to logout?',
      },
      resetPasswordDialog: {
        content: `An email with a reset password link will be sent to ${
          user!.email
        }. Do you want to proceed?`,
      },
    },
    it: {
      logout: 'Esci',
      logoutDialog: {
        title: 'Esci',
        content: 'Vuoi davvero uscire?',
      },
      resetPasswordDialog: {
        content:
          'Ti verrà inviata una mail con un link per il reset della password. Vuoi procedere?',
      },
    },
    es: {
      logout: 'Logout',
      logoutDialog: {
        title: 'Logout',
        content: 'Do you really want to logout?',
      },
      resetPasswordDialog: {
        content: `An email with a reset password link will be sent to ${
          user!.email
        }. Do you want to proceed?`,
      },
    },
  };

  const tx = txs[lang];

  return (
    <Menu placement="bottom-end" autoSelect={false}>
      <MenuButton as={Avatar} w="24px" h="24px" cursor="pointer" src={UserAvatar} />
      <MenuList>
        <MenuGroup>
          <MenuItem _hover={{ bg: 'white' }} cursor="default">
            <Flex direction="column">
              <Text color="gray.600">{user!.firstName + ' ' + user!.lastName}</Text>
              <Text fontSize={15} color="gray.400">
                {user!.email}
              </Text>
            </Flex>
          </MenuItem>
        </MenuGroup>

        <MenuDivider />

        <MenuItem color="gray.700" onClick={onResetPsw}>
          Reset Password
        </MenuItem>

        <MenuItem color="gray.700" onClick={onLogout}>
          {tx.logout}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UserMenu;
